import { Stack, Text } from 'braid-design-system';
import HotjarMask from 'src/components/common/HotjarMask';
import { observer } from 'mobx-react';
import type { CredentialInfo } from '@seek/ca-myprofile-utils';

interface VerificationInfoItemProps {
  verificationInfo: CredentialInfo;
}

const VerificationInfoItem = observer(
  ({ verificationInfo: { name, values } }: VerificationInfoItemProps) => {
    const label = name ? `${name}: ` : '';
    return (
      <Text>
        <HotjarMask>{`${label}${values.join(', ')}`}</HotjarMask>
      </Text>
    );
  },
);

interface VerificationInfoItemListProps {
  verificationInfo: CredentialInfo[];
}

export const VerificationInfoItemList = observer(
  ({ verificationInfo }: VerificationInfoItemListProps) => (
    <Stack space="small">
      {verificationInfo.map((info) => (
        <VerificationInfoItem key={`${info.name}`} verificationInfo={info} />
      ))}
    </Stack>
  ),
);
